export default __webpack_public_path__ + "static/media/automation.a4fd70db.svg";